import { getRedirectsList } from '~/api/callbacks';
import type { Redirect } from '~/types/redirect';
import type {
  MetaResponsePaginationByPage,
  Strapi5ResponseMany,
} from '@nuxtjs/strapi';

export default defineNuxtRouteMiddleware(async (to) => {
  if (import.meta.client) return;

  let page = 1;
  let totalPages;

  do {
    const { data, meta } = (await getRedirectsList({
      page,
      pageSize: 20,
    })) as Strapi5ResponseMany<Redirect>;

    const currentRedirect = data.find(
      (redirect: Redirect) => redirect.from === to.path,
    );

    if (currentRedirect) {
      return navigateTo(currentRedirect.to, { redirectCode: 301 });
    }

    totalPages = (meta.pagination as MetaResponsePaginationByPage).pageCount;
    page += 1;
  } while (page <= totalPages);
});
